
import { Component, Vue } from 'vue-property-decorator';
import { getAssetDetails } from '@pazion/pazion-catalog/src/services/contracts-service';
import PazRefreshButton from "@pazion/pazion-core/src/components/controls/PazRefreshButton.vue";
import { ContractAsset } from '@pazion/pazion-catalog/src/models/contracts.model';

@Component({
  components: {
    PazRefreshButton
  }
})
export default class AssetsListing extends Vue {

  public loading: boolean = false;

  public search: string | null = null;


  private assetItems = [] as ContractAsset[];
  private _timerId = null;

  private defualtReqParams = { expand: 'attributeValue,contractAssetAttribute,assetType' }

  public productionLinesData = [];


  public footerProps = {
    itemsPerPageOptions: [50, 100, 200, -1]
  };

  public TableDataHeaders = [
    {
      text: "Type",
      align: "left",
      cellClass: "nowrap",
      value: "assetType.nameTech",
      groupable: false,
    },
    {
      text: "Name",
      align: "left",
      cellClass: "nowrap",
      value: "name",
      groupable: false
    },
    {
      text: "Serial number",
      align: "left",
      cellClass: "nowrap",
      value: "serialNumber",
      groupable: false
    },
    {
      text: "Location",
      align: "left",
      cellClass: "nowrap",
      value: "location",
      groupable: false
    },
    {
      text: "actions",
      align: "right",
      cellClass: "nowrap",
      value: "actions",
      groupable: false
    }
  ];


  get getAssetItems() {
    return this.assetItems
  }

  createSearchString(search: string) {
    return search.length > 0 ? { like: `%${this.search}%` } : null;
  }

  //NOTE: Search
  onSearch() {
    clearTimeout(this._timerId);
    this._timerId = setTimeout(async () => {
      const searchString = this.createSearchString(this.search);
      const queryParams = searchString
        ? {
          // TODO: Add search fields.
          filter: JSON.stringify({
            "operator": "OR",
            name: searchString,
            nameTech: searchString,
            'a.groupName': searchString,
            'av.Value': searchString
          }),
        } : {}
      await this.fetchData(queryParams);
    }, 800);
  }

  async fetchData(queryParams?: object) {
    try {
      const queries = queryParams ? queryParams : this.defualtReqParams;
      this.loading = true;
      const res = await getAssetDetails(queries);
      if (!res) return
      this.assetItems = res;
      this.loading = false;
    } catch (error) {
      this.loading = false
    }
  }

  mounted() {
    this.fetchData(this.defualtReqParams);
  }

}//
